export const routes = {
  root: "/",
  aplicacion: "/aplicacion",
  aplicaciones: "/aplicaciones",
  cuestionarios: "/cuestionarios",
  cuestionarioCrear: "/cuestionarios/crear-cuestionario",
  cuestionarioPreview: "/cuestionarios/:id/preview",
  usuarios: "/usuarios",
  home: "/home",
  documentosAsociados: "/documentos-asociados",
  cuestionariosPorFase: "/cuestionarios-por-fase",
  usuarioDetalle: "/usuarios/:id/detalle",
  usuarioCrear: "/usuarios/crear",
  asignacionCrear: "/asignacion/crear",
  forbidden: "/403",
  aspectos: "/aspectos",
  tiposOpcionesRespuesta: "/tipos-opciones-respuesta",
  preguntas: "/preguntas",
  usuariosLogin: "/users/login",
  instrumentos: "/instrumentos",
  reporteAsignaciones: "/aplicaciones/:appId/asignaciones",
  reportes: "/reportes",
};
